export default __webpack_public_path__ + "static/media/rawpixel-411166-unsplash@2x.2250f019.png";